import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=4e84400b&scoped=true&"
import script from "./DashboardFooter.vue?vue&type=script&lang=js&"
export * from "./DashboardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e84400b",
  null
  
)

export default component.exports